import React, { useEffect, useState } from 'react';
import './index.css';
import SearchInput from 'common/components/SearchInput';

//import filter, sort, export and plus
import { ReactComponent as FilterIcon } from 'common/icons/filter.svg';
import { ReactComponent as SortIcon } from 'common/icons/sort.svg';
import { ReactComponent as ExportIcon } from 'common/icons/export.svg';
import { ReactComponent as PlusIcon } from 'common/icons/plus.svg';
import IconButton from 'common/components/IconButton';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CustomTable from 'pages/ContactsPage/components/CustomTable';
import UserDataTableProps from 'common/types/UserDataTableProps';
import sendFetch from 'common/utils/fetch';
import { useAuth } from 'common/context/AuthContext';
import ButtonDropdownMenuProps from 'common/types/ButtonDropdownMenuProps';
import MenuIconButton from 'common/components/MenuIconButton';
import { TableNavButton } from 'common/styles/TableNavButton';

export default function ContactsPage() {
  const { companyId } = useAuth();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get('search') || '';
  const type = searchParams.get('type') || '';

  const [searchValue, setSearchValue] = useState(search);
  const [tableLoading, setTableLoading] = useState(false);
  const [isAddMenuOpen, setIsAddMenuOpen] = useState(false);
  const [isExportMenuOpen, setIsExportMenuOpen] = useState(false);
  const [tableData, setTableData] = useState<UserDataTableProps[] | string>([]);

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
  };

  type ResponseProps = UserDataTableProps[] | string;

  useEffect(() => {
    const fetchTableData = async () => {
      setTableLoading(true);
      let link = 'https://api-workspace.astin.net/api/user/get-all-user-list';
      if (type === 'clients') {
        link = 'https://api-workspace.astin.net/api/user/get-client-list';
      } else if (type === 'workers') {
        link = 'https://api-workspace.astin.net/api/user/get-employee-list';
      }
      const formData = new FormData();
      formData.append('companyId', companyId);
      const response: [number, ResponseProps] = await sendFetch(link, {
        method: 'POST',
        data: formData,
      });
      console.log(response);
      if (response[0] === 200) {
        setTableLoading(false);
        setTableData(response[1]);
      } else if (response[1] = 'Empty list') {
        setTableLoading(false);
      }
    };
    if (companyId) {
      fetchTableData();
    }
  }, [type, companyId]);

  const handleTypeChange = (value: string | null) => {
    if (value) {
      searchParams.set('type', value);
    } else {
      searchParams.delete('type');
    }
    setSearchParams(searchParams, { replace: true });
  };

  const handleSearchSubmit = (value:string) => {
    if (value) {
      searchParams.set('search', value);
    } else {
      searchParams.delete('search');
    }
    setSearchParams(searchParams, { replace: true });
  };

  const ExportButtonMenu:ButtonDropdownMenuProps[] = [
    {
      label: 'Microsoft Excel (.xlsx)',
      onClick: () => {},
    },
    {
      label: 'OpenDocument (.ods)',
      onClick: () => {},
    },
    {
      label: 'PDF (.pdf)',
      onClick: () => {},
    },
    {
      label: 'Веб-сторінка (.html)',
      onClick: () => {},
    },
    {
      label: 'Формат CSV (.csv)',
      onClick: () => {},
    },
    {
      label: 'Формат TSV (.tsv)',
      onClick: () => {},
    },
  ];
  
  // Новий клієнт, Новий робітник

  const AddUserButtonMenu:ButtonDropdownMenuProps[] = [
    {
      label: 'Новий клієнт',
      onClick: () => {navigate({ pathname:'add_client' });},
    },
    {
      label: 'Новий робітник',
      onClick: () => {navigate({ pathname:'add_worker' });},
    },
  ];

  const closeAllMenus = () => {
    setIsExportMenuOpen(false);
    setIsAddMenuOpen(false);
  };

  const handleExportClick = (e:React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    closeAllMenus();
    setIsExportMenuOpen(!isExportMenuOpen);
  };

  const handleAddClick = (e:React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    closeAllMenus();
    setIsAddMenuOpen(!isAddMenuOpen);
  };
  // close everything on clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest('.dropdown-menu')) {
        closeAllMenus();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);


  return (
    <section className="contacts-section">
      <h2 className='new-h2'>Контакти</h2>
      <div className='contacts-menu-line'>
        <div className='contacts-menu-wrapper'>
          <SearchInput value={searchValue} onChange={handleSearchChange} searchFunction={handleSearchSubmit} />
          <IconButton label='Фільтри'>
            <FilterIcon className='svg-black' />
          </IconButton>
          <IconButton label='Сортування'>
            <SortIcon className='svg-black' />
          </IconButton>
        </div>
        <div className='contacts-menu-wrapper'>
          <MenuIconButton label='Експортувати' isOpen={isExportMenuOpen} onClick={handleExportClick} menuData={ExportButtonMenu}>
            <ExportIcon className='svg-black' />
          </MenuIconButton>
          <MenuIconButton label='Додати клієнта' isOpen={isAddMenuOpen} onClick={handleAddClick} menuData={AddUserButtonMenu}>
            <PlusIcon className='svg-black' />
          </MenuIconButton>
          <div className='table-navigation-wrapper'>
            <TableNavButton onClick={()=>{handleTypeChange('all');}} className={type !== 'clients' && type !== 'workers' && 'active'}>Усі</TableNavButton>
            <TableNavButton onClick={()=>{handleTypeChange('clients');}} className={type === 'clients' && 'active'}>Клієнти</TableNavButton>
            <TableNavButton onClick={()=>{handleTypeChange('workers');}} className={type === 'workers' && 'active'}>Робітники</TableNavButton>
          </div>
        </div>
      </div>
      <CustomTable loading={tableLoading} data={typeof tableData === 'object' && tableData} searchValue={search} />
    </section>
  );
}